import { dividerClasses, Theme, toolbarClasses, tooltipClasses } from '@mui/material'
import { appBarHeight } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1AppBarStyles: moduleStyleType = {
    appBar: (theme: Theme) => ({
        overflowX: 'auto',
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 0,
        backgroundColor: 'primary.extraDark',
        color: 'primary.contrastText',

        [` .${toolbarClasses.root}`]: {
            minHeight: appBarHeight,
        },
    }),
    mobileLogo: {
        minWidth: '30px',
    },
    tooltipPopper: {
        [` .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'grey.800',
            color: 'text.light',
        },
    },
    userMenuAvatar: {
        p: 0,
        pr: 2,
    },
    unselectableMenuItem: {
        py: 2,
        pl: 1,
        cursor: 'default',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    userMenuPopper: {
        mt: 1,
        [`.${dividerClasses.root}`]: {
            my: 0,
        },
    },
    userMenuItem: {
        height: '34px',
        '&:hover, &:focus-visible': {
            backgroundColor: 'primary.extraLight',
            color: 'primary.main',
        },
    },
    showInSmallScreen: {
        display: { lg: 'none', xs: 'flex' },
    },
    hideInSmallScreen: {
        display: { lg: 'flex', xs: 'none' },
    },
}
